import LinkBox, { LinkBoxProps } from '../LinkBox';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
import { blockIfSelecting } from './blockIfSelecting';

export interface SelectableLinkBoxProps extends Omit<LinkBoxProps, 'color'> {
  color: LinkBoxProps['color'] | false;
}

const StyledLinkBox = styled(LinkBox)<SelectableLinkBoxProps>(() => ({
  userSelect: 'text',
}));

const SelectableLinkBox = forwardRef<HTMLButtonElement, SelectableLinkBoxProps>(({ onClick, ...props }, ref) => (
  <StyledLinkBox onClick={blockIfSelecting(onClick)} ref={ref} {...props} />
));

SelectableLinkBox.displayName = 'SelectableLinkBox';

export default SelectableLinkBox;
